module.exports = __webpack_public_path__ + "img/appDownLoad.6d3d5b97.png";